import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

/** Where a paused account goes to put things right: the claims page with the
 *  Account Issues modal open — the same target as the global banner's "Fix it",
 *  so however a user meets the pause they land in one flow. */
export const WHITELISTING_FIX_ROUTE = "/account/claims?fix=1";

/** Hover label on a greyed control. Desktop-only by nature, so it is a hint,
 *  never the explanation — the redirect below is. */
export const WHITELISTING_PAUSED_HINT = "Paused — restore the missing credit text to continue";

/**
 * A click on a control blocked because the account is credit-paused (ToU §17.4)
 * takes the user to the Account Issues modal rather than failing. Before this,
 * the handlers returned early and the buttons were really `disabled`, so a click
 * produced nothing at all on touch (the tooltip is hover-only) and the refusal
 * read as a broken button.
 *
 * Consequence for callers: greyed controls must use `aria-disabled`, NOT
 * `disabled` — a disabled button fires no click, so this would never run.
 */
export const useWhitelistingPausedRedirect = (): (() => void) => {
  const navigate = useNavigate();
  return useCallback(() => navigate(WHITELISTING_FIX_ROUTE), [navigate]);
};
